module.exports = __webpack_public_path__ + "img/icon_download_logo.a51f8668.png";